import React, { Component } from "react";
import { ButtonToolbar, Button, Form, Image, Row } from "react-bootstrap";
import { Field } from "../../component/FieldComponent";
import { get, isFunction } from "lodash";
import ForwardToTeam from "./forwardToTeam";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  setIssueStatusAction,
  postCommentAction,
  replyAction,
  issueClarificationAction
} from "../../actions/issuesListAction.actions";
import { getIssueList } from "../../actions/common.action";
import { bindActionCreators } from "redux/es/redux";
import { modifyDataForPost } from "./helper";
import {
  ERROR_MSG,
  FILE_FORMATS,
  STATUS,
  MAX_CHARACTER_LIMIT
} from "../../constant";
import ReassignForClarification from "./reassignForClarrification";
import MarkAsDuplicate from "./markAsDuplicate";
import ChangeStatus from "./changeStatus";
import AddDecision from "../agendaDetails/AddDecision.issueList";
import {
  getIssueMeetingByIdAction,
  getIssueDetails
} from "../../actions/issueDetail.action";
import { withRouter } from "react-router-dom";
import LoaderTemplate from "../../component/LoaderTemplate";
import { ActionLoaderTemplate } from "../../component/LoadersTemplate";
import DisplayByPermission from "../../component/DisplayByPermission";
import { LoaderPage } from "../../component/Loader";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  changeProjectStatus,
  getProjectDetails
} from "../../actions/projectDetail.action";
import {
  UploadAttachmentsWithTitleComponent,
  DisplayAttachments
} from "../reusableComponent";
import IconPin from "../../assets/icon-pin.png";
import { unHoldIssueAction } from "../../actions/issues.action";
import AddDecisionConfirmationModal from "./addDecisionCofirmationModal";
import { getAgendaIssueAction } from "../../actions/mom.action";
import { handleLanguage, handlePaste } from "../../helper";
import CircleWithExclamation from "../../assets/circle-with-exclamation.svg";
import { successToastStyle, errorToastStyle } from "../../customToast";
import InfoIcon from "../../assets/small-info-icon.svg";
import TooltipComponent from "../../component/TooltipComponent";
import uparrow from "../../assets/uparrowsvg.svg";
import "../../sass/styling/_Newbutton.scss";
import { IssueEditButton } from "../issueDetail/IssueEditButton";
import { ConfirmationComponent } from "../ConfirmationComponent";
import { ReviewAndSend } from "../reusableComponent/ReviewAndSend";
const FIXED_ACTIONS = {
  "REASSIGN FOR CLARIFICATION": "REASSIGN FOR CLARIFICATION",
  "FORWARD TO TEAM": "FORWARD TO TEAM",
  REPLY: "REPLY",
  "ADD DECISION": "ADD DECISION",
  Mark_As_Duplicate: "Mark_As_Duplicate"
};

let severity = {
  PRIMARY: "btn-orange",
  SECONDARY: "btn-blue",
  TERNARY: "btn-orange-invert",
  default: "btn-orange"
};

const ACTION_TYPE = "WITH_COMMENT";

const MESSAGES_CONSTANT = {
  "Verify and Send for Consideration":
    "Verify & assign to PMG for further action",
  "Send for Under Process":
    "Verify & assign to its corresponding Recipient Ministry/State",
  "Send to Decision": "Assign to PMG for confirming the resolution of issue",
  "Add Decision": "Add decision taken in meeting or by higher authority",
  Reply: "Reply on requested clarification",
  "Forward to Team": "Forward to my team(s) for further action",
  "Reject Issue": "Not valid and outside the ambit of PMG",
  Resolve: "Confirm issue resolution and assign to PMG for closure",
  Hold: "Issue on hold and can't be part of PMG monitoring for the time being",
  "Reassign For Clarification":
    "Reassign to other stakeholder for issue/update clarification",
  Unhold: "Unhold to revert the issue to its previous stage",
  addMoreIssue: "Add Issue",
  markAsDuplicate: "Mark Duplicate"
};

const ToolTip = ({
  text,
  children,
  id,
  containerClass,
  placement = "bottom"
}) => {
  return (
    <OverlayTrigger
      defaultShow={false}
      placement={placement}
      overlay={
        <Tooltip id={id} className={`issues-actions-tooltip ${containerClass}`}>
          {text || null}
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
};
class IssueActions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      action: "",
      files: [],
      showAddDecisionConfirmationModal: false,
      agendasAssociatedWithIssue: [],
      checkAgenda: true,
      canUploadVideo: true,
      languageError: null,
      pasteError: false,
      pastedText: "",
      markduplicatebtn: true,
      showCommentPopUp: false,
      buttonDisplay: false,
      reviewAndSentTo: false,
      isChecked: null,
      isNotChecked: null,
      projectMom: "",
      errors: {
        projectMOM: "",
        documents: ""
      }
    };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { resetAction } = nextProps;
    // eslint-disable-next-line no-unused-expressions
    resetAction;
  }

  onChange = (value, key) => {
    this.setState({
      showCommentPopUp: false,
      buttonDisplay: false,
      reviewAndSentTo: false,
      isChecked: null,
      isNotChecked: null,
      errors: {},
      files: []
    });
    localStorage.setItem("DisplayButton", "0");
    if (
      value == "REASSIGN FOR CLARIFICATION" ||
      "FORWARD TO TEAM" ||
      "Mark_As_Duplicate"
    ) {
      this.props.onCloseButton("1");
    }
    if (value == "") {
      this.props.onCloseButton("0");
    }

    this.setState({ [key]: value }, () => {
      if (window.event.inputType === "insertFromPaste") {
        this.pasteLanguage();
      }
    });
    if (key === "comment") {
      if (value.length > MAX_CHARACTER_LIMIT) {
        value = value.slice(0, MAX_CHARACTER_LIMIT);
      }
    }
  };

  onError = (value, key) => {
    this.setState(prevState => ({
      error: {
        ...prevState.error,
        [key]: value
      }
    }));
  };

  onPostComment = () => {
    const {
      issueDetails: { id },
      postCommentDispatch,
      callApiOnSuccess
    } = this.props;
    const { files, comment } = this.state;

    // error
    if (comment === undefined || !comment.trim() || comment === "") {
      this.setState(prevState => ({
        languageError: false,
        pasteError: false,
        error: {
          ...prevState.error,
          comment: {
            error: comment === undefined || !comment.trim() || comment === "",
            message:
              comment === undefined || !comment.trim() || comment === ""
                ? ERROR_MSG.DEFAULT_MSG
                : ""
          }
        }
      }));
    } else {
      const modifyData = modifyDataForPost({ files, comment, id });
      this.setState(
        {
          isCommentLoading: STATUS.LOADING
        },
        async () => {
          const resp = await postCommentDispatch(undefined, modifyData);
          if (resp) {
            const { status, message } = resp;
            (status &&
              toast.success(
                <p className="toast-text-alignment">{message}</p>,
                successToastStyle
              )) ||
              toast.error(
                <p className="toast-text-alignment">{message}</p>,
                errorToastStyle
              );
            isFunction(callApiOnSuccess) && callApiOnSuccess();
            this.setState(
              prevState => ({
                isCommentLoading: (status && STATUS.SUCCESS) || STATUS.ERROR,
                comment: "",
                files: [],
                reset: true,
                error: {
                  ...prevState.error,
                  comment: {}
                }
              }),
              () => {
                this.setState({
                  reset: false
                });
              }
            );
          } else {
            toast.error(
              <p className="toast-text-alignment">
                {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
              </p>,
              errorToastStyle
            );
          }
        }
      );
    }
  };

  //
  onActionClick = value => {
    const { issueDetails } = this.props;
    const { name, actionType } = value;
    this.setState({
      action: name,
      actionType
    });
    if (
      value.name == "RESOLVE" ||
      value.name == "REJECT ISSUE" ||
      value.name == "REJECT" ||
      value.name == "RESOLVED AND SEND TO STATE PMG" ||
      value.name == "RESOLVED & SEND TO PMG"
    ) {
      this.setState({ showCommentPopUp: false });
    } else if (value.name == "REVIEW AND SEND TO PMG") {
      if (get(issueDetails, "issueReviewedBySM") == null) {
        this.setState({ reviewAndSentTo: true });
      } else this.setState({ showCommentPopUp: true });
    } else {
      this.setState({ showCommentPopUp: true });
    }
    if (value.actionType == "WITHOUT_COMMENT") {
      this.setState({ buttonDisplay: true });
    } else {
      console.log(value.name);
      this.props.onCloseButton("1");
      localStorage.setItem("DisplayButton", "0");
      this.setState({ buttonDisplay: false });
    }
  };

  // action buttons
  createTemplateForAction = () => {
    const { actionsData, issueDetails } = this.props;
    const actions =
      //   [  {
      //     "id": 1858,
      //     "name": "SEND TO RECIPIENT",
      //     "description": "Verify & assign to its corresponding Recipient District/State-Department",
      //     "workflowActionSeverity": null,
      //     "actionType": "WITHOUT_COMMENT"
      // },
      // {
      //     "id": 957,
      //     "name": "REJECT ISSUE",
      //     "description": "Not valid and outside the ambit of PMG",
      //     "workflowActionSeverity": "PRIMARY",
      //     "actionType": "WITH_COMMENT"
      // }]
      get(actionsData, "actions") || get(issueDetails, "actions") || [];
    return actions.map((value, index) => {
      return (
        get(value, "name") && (
          <>
            <ToolTip text={get(value, "description")}>
              <Button
                className={`${severity[
                  get(value, "workflowActionSeverity", "")
                ] || severity.default} no-padding-new 
                ${
                  get(value, "name", "NA") == "REJECT ISSUE"
                    ? "new-rejectissue-btn"
                    : null
                }
                || ${
                  get(value, "name", "NA") == "REJECT"
                    ? "new-rejectissue-btn"
                    : null
                }
                || ${
                  get(value, "name", "NA") == "RESOLVE" ? "resolvebtn" : null
                }`}
                onClick={e => {
                  this.onActionClick(value);
                }}
                key={`button-${index}`}
                style={{
                  width:
                    get(value, "name", "NA") == "VERIFY AND SEND TO PMG"
                      ? "23%"
                      : null,
                  display: this.props.markDuplicateBTN == 1 ? "none" : null
                }}
              >
                {get(value, "name", "NA")}
              </Button>
            </ToolTip>

            {/* {get(value, "name", "NA")=="REJECT ISSUE"?<>
              <ToolTip text={get(value, "description")}>
              <Button
                className={`${severity[
                  get(value, "workflowActionSeverity", "")
                ] || severity.default} no-padding-new new-rejectissue-btn`}
                onClick={e => {
                  this.onActionClick(value);
                }}
                key={`button-${index}`}
              
              >
               REJECT ISSUE
              </Button>
              </ToolTip>
              </>:null}
              {get(value, "name", "NA")=="VERIFY AND SEND TO PMG"?<>
              <ToolTip text={get(value, "description")}>
              <Button
                className={`${severity[
                  get(value, "workflowActionSeverity", "")
                ] || severity.default} no-padding-new`}
                onClick={e => {
                  this.onActionClick(value);
                }}
                key={`button-${index}`}
                //style={{width:"113px"}}
              >
               VERIFY AND SEND TO PMG
              </Button>
              </ToolTip>
              </>:null}
             */}
          </>
        )
      );
    });
  };

  onDelete = e => {
    const { resetAction } = this.props;
    resetAction(e);
  };
  handleButtonClose = () => {
    this.props.onCloseButton("0");
  };
  // set issue status
  setIssueStatus = async e => {
    this.setState({ showCommentPopUp: false });
    localStorage.setItem("DisplayButton", "0");
    this.props.onCloseButton("0");
    const { action } = this.state;
    const {
      setIssueStatusDispatch,
      issueDetails = {},
      callApiOnSuccess,
      isIssueList
    } = this.props;
    const resp = await setIssueStatusDispatch(undefined, {
      action,
      issueCommentCO: {
        issueId: get(issueDetails, "id", null)
      },
      reviewedBySM: this.state.isNotChecked
        ? !this.state.isNotChecked
        : this.state.isChecked,
      momFiles: this.state.isChecked
        ? this.state.files.map(val => val.id)
        : null,
      momDescription: this.state.isChecked ? this.state.projectMom : null
    });
    if (resp) {
      if (!isIssueList) {
        setTimeout(() => {
          window.location.reload(true);
        }, 1500);
      }
      const { status, message } = resp;
      (status &&
        toast.success(
          <p className="toast-text-alignment">{message}</p>,
          successToastStyle
        )) ||
        toast.error(
          <p className="toast-text-alignment">{message}</p>,
          errorToastStyle
        );
      typeof callApiOnSuccess === "function" && callApiOnSuccess();
      this.setState({
        action: ""
      });
    }
  };

  handleClose = () => {
    this.setState({
      action: null
    });
  };

  getImageStatus = status => {
    this.setState({
      imageStatus: status
    });
  };

  onVerifyProject = () => {
    localStorage.setItem("DisplayButton", "0");
    this.props.onCloseButton("0");
    const { issueDetails, callApiOnSuccess, isIssueList } = this.props;
    this.setState(
      {
        isProjectVerifing: STATUS.LOADING,
        showCommentPopUp: false
      },
      async () => {
        const response = await changeProjectStatus(undefined, {
          comment: "Project is verified.",
          projectId: issueDetails && issueDetails.project.id,
          projectStatus: "VERIFIED",
          isIssueVerified: true
        });
        const { data } = response;
        data.status
          ? toast.success(
              <p className="toast-text-alignment">{data.message}</p>,
              successToastStyle
            )
          : toast.error(
              <p className="toast-text-alignment">{data.message}</p>,
              errorToastStyle
            );

        if (!isIssueList) {
          setTimeout(() => {
            window.location.reload(true);
          }, 1500);
        }
        this.setState(
          { isProjectVerifing: false, action: null, actionType: null },
          () => {
            callApiOnSuccess && callApiOnSuccess();
          }
        );
      }
    );
  };

  onSuccessUploadOfAttachmets = async data => {
    try {
      this.setState(prevState => ({ files: [...prevState.files, data] }));
    } catch (error) {
      console.error(error.message);
    }
  };

  // uploded comes tru in case of file
  // is uploaded
  onToggleAttachment = file => {
    this.setState(prevState => {
      return {
        toggleAttachementDisplay: !prevState.toggleAttachementDisplay,
        files: file ? [file] : prevState.files,
        errors: { ...prevState.errors, documents: "" }
      };
    });
  };

  // delete attachments
  onRemoveFile = ({ id }) => {
    try {
      this.setState(prevState => ({
        files: prevState.files.filter(val => val.id !== id)
      }));
    } catch (error) {
      console.log(`Error while deleting the image ${error.message}`);
    }
  };

  unHoldIssue = async () => {
    let {
      issueDetails: { id },
      unHoldIssueAction,
      callApiOnSuccess
    } = this.props;

    let resp = await unHoldIssueAction(id);
    if (resp) {
      this.setState(
        { isProjectVerifing: false, action: null, actionType: null },
        () => {
          callApiOnSuccess && callApiOnSuccess();
        }
      );
    }
  };
  handleCloseAddDecisionConfirmationModal = () => {
    this.setState({
      showAddDecisionConfirmationModal: false
    });
  };

  showAddDecisionConfirmationModal = () => {
    const {
      issueDetails,
      defaultOpen,
      callApiOnSuccess,
      filterArray,
      meetingListData
    } = this.props;
    const {
      agendasAssociatedWithIssue,
      showAddDecisionConfirmationModal
    } = this.state;
    return agendasAssociatedWithIssue.length !== 0 ? (
      <>
        <AddDecisionConfirmationModal
          show={showAddDecisionConfirmationModal}
          handleClose={this.handleCloseAddDecisionConfirmationModal}
          issueDetails={issueDetails}
          defaultOpen={defaultOpen}
          callApiOnSuccess={callApiOnSuccess}
          filterArray={filterArray}
          meetingListData={meetingListData}
          agendasAssociatedWithIssue={agendasAssociatedWithIssue}
          showAddDecisionConfirmationModal={showAddDecisionConfirmationModal}
        />
      </>
    ) : (
      <>
        <AddDecision
          show={true}
          meetingListData={get(meetingListData, "data")}
          handleClose={() =>
            this.setState({
              showAddDecisionConfirmationModal: false
            })
          }
          issues={issueDetails}
          project={
            get(issueDetails, "project") || get(issueDetails, "projectIssueDTO")
          }
          callApiOnSuccess={callApiOnSuccess}
          defaultOpen={defaultOpen}
          issueListStatus={true}
          filterArray={filterArray}
          showSaveAsDraft={false}
          callFromIssueAction={true}
        />
      </>
    );
  };

  getAgendaListForIssue = async () => {
    const { issueDetails } = this.props;
    const response = await getAgendaIssueAction(
      undefined,
      issueDetails.id,
      this.state.checkAgenda
    );
    if (response) {
      if (response.data.data !== null) {
        this.setState({
          agendasAssociatedWithIssue: response.data.data
        });
      }
    } else {
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
    }
    this.setState({ showAddDecisionConfirmationModal: true });
  };
  inputLanguage = event => {
    if (window.event.inputType !== "insertFromPaste") {
      let hasInputValue = handleLanguage(event);
      this.setState({
        languageError: hasInputValue,
        pasteError: false
      });
    }
  };

  pasteLanguage = () => {
    let { filterString, hasBadValue } = handlePaste(this.state.comment);
    if (hasBadValue === true) {
      this.setState({
        pasteError: hasBadValue,
        comment: filterString
      });
    }
  };

  checkBoxChange = data => {
    if (data == "NO") {
      this.setState({ isNotChecked: true, isChecked: false });
    } else this.setState({ isNotChecked: false, isChecked: true });
  };

  validateMOMForm = () => {
    const { projectMom, files } = this.state;
    let errors = {};
    if (!projectMom || !projectMom.trim()) {
      errors.projectMOM = "This field is required";
    }
    if (!files || files.length === 0) {
      errors.documents = "This field is required";
    }
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  checkuploadComment = () => {
    if (this.state.isChecked) {
      if (!this.validateMOMForm()) return;
      this.setState({ reviewAndSentTo: false });
      this.setIssueStatus();
    } else if (this.state.isNotChecked) {
      this.setState({ reviewAndSentTo: false });
      this.setIssueStatus();
    } else {
    }
  };

  setProjectMom = data => {
    this.setState(prev => ({
      projectMom: data,
      errors: {
        ...prev.errors,
        projectMOM: ""
      }
    }));
  };

  onBlur = value => {};

  render() {
    const {
      action,
      comment,
      error,
      files,
      actionType,
      isProjectVerifing,
      isCommentLoading,
      imageStatus,
      toggleAttachementDisplay,
      canUploadVideo,
      pasteError,
      languageError,
      showCommentPopUp,
      buttonDisplay,
      reviewAndSentTo
    } = this.state;
    const {
      issueDetails,
      replyActionDispatch,
      issueClarificationDispatch,
      defaultOpen,
      meetingListData,
      actionsData,
      callApiOnSuccess,
      isLoading,
      isApiLoading,
      filterArray,

      handleOnClick,
      projectData,
      markDuplicateBTN,
      isIssueList
    } = this.props;
    const actionsInfo = actionsData || issueDetails || {};
    const {
      actions,
      askForClarificationList,
      replyToList,
      markAsDuplicateList
    } = actionsData || issueDetails || {};
    const { project, projectIssueDTO } = actionsInfo;
    //console.log(actions)
    const projectStatus =
      get(project, "status") || get(projectIssueDTO, "status");
    const isActionAvailable = (actions || []).find(value => {
      return value && value.name === action;
    });
    return (
      <React.Fragment>
        {this.state.showAddDecisionConfirmationModal === true &&
          this.showAddDecisionConfirmationModal()}
        <LoaderPage
          loading={
            isCommentLoading === STATUS.LOADING ||
            imageStatus === STATUS.LOADING ||
            isApiLoading === STATUS.LOADING ||
            isProjectVerifing
          }
        />
        <DisplayByPermission
          display={!action || (!action && defaultOpen) || buttonDisplay}
        >
          <React.Fragment>
            {/* <DisplayByPermission display={get(actionsInfo, "addComment")}>
              <div className="d-flex update-comment-tooltip" >
                <div className="update-heading">Update Status/Comment</div>
                <TooltipComponent
                  classes="add_issue_tooltip"
                  smallIconInfo={InfoIcon}
                  placement="right"
                  content={
                    <>
                      Latest update, indicate latest pendency in values, for eg:{" "}
                      <br /> pending/total (km, Ha, units, etc), efforts
                      undertaken to resolve <br /> issue, timeline for
                      completing pending tasks (if any).
                    </>
                  }
                />
              </div>
              <Form.Group
                controlId="exampleForm.ControlTextarea1"
                className={`comment-area issue-detail-actions ${
                  languageError === true ||
                  (pasteError === true && comment !== "")
                    ? "language-error-border-alert"
                    : ""
                }`}
              >
                <Field
                  as="textarea"
                  keyName="comment"
                  rows="3"
                  value={comment}
                  className="add-comment"
                  maxLength="500"
                  placeholder="Latest update, indicate latest pendency in values, for eg: pending/total (km, Ha, units, etc), efforts undertaken to resolve issue, timeline for completing pending tasks (if any)."
                  onInput={this.inputLanguage}
                  onChange={this.onChange.bind(this)}
                  onError={this.onError.bind(this)}
                  isInvalid={get(error, "comment.error")}
                />
                {toggleAttachementDisplay ? (
                  <UploadAttachmentsWithTitleComponent
                    displayModal={toggleAttachementDisplay}
                    onCloseModal={this.onToggleAttachment}
                    fileFormats={FILE_FORMATS}
                    onSubmit={this.onSuccessUploadOfAttachmets}
                    canUploadVideo={canUploadVideo}
                  />
                ) : null}
                <Form.Control.Feedback type="invalid">
                  {languageError === true ||
                  (pasteError === true && comment !== "")
                    ? ""
                    : get(error, "comment.message")}
                </Form.Control.Feedback>
              </Form.Group>
              <Row className="align-action justify-content-between">
                <span className="remaining-char">
                  Remaining characters :{" "}
                  {comment
                    ? MAX_CHARACTER_LIMIT - comment.length
                    : MAX_CHARACTER_LIMIT}
                </span>
                {languageError || (pasteError && comment !== "") ? (
                  <div className="warning">
                    <Image src={CircleWithExclamation} />
                    Only English language is supported.
                  </div>
                ) : (
                  <></>
                )}
              </Row>
              <Form.Group className="field-attachment issue-detail-action">
                <div className="attachment-box">
                  <DisplayAttachments
                    filesArr={files}
                    onRemoveFile={this.onRemoveFile}
                    addAttchementRequired={false}
                    classes="attachments"
                  />
                  <div
                    className="add-attachment"
                    onClick={this.onToggleAttachment}
                  >
                    <div className="add-attachment-button">
                      <Image src={IconPin} alt="Attachment Icon" />
                      Add Attachment
                    </div>
                  </div>
                </div>
                <div className="button-group post-comment">
                  <Button
                    className="btn-orange-invert btn-small print-btn post-btn"
                    onClick={this.onPostComment}
                  >
                    <div className="post-icon orange" />
                    Add Comment
                  </Button>
                </div>
              </Form.Group>
            </DisplayByPermission>  */}
            <div
              className="row"
              style={{ display: markDuplicateBTN == 1 ? "none" : null }}
            >
              <h3 className="heading-actions" style={{ marginLeft: "2%" }}>
                Actions on Issue{" "}
              </h3>
            </div>
            {/* {get(actionsInfo, "addMoreIssue") ||
            get(actionsInfo, "clarification") ||
            get(actionsInfo, "forwardToTeam") ||
            get(actionsInfo, "addDecision") ||
            get(actionsInfo, "reply") ||
            get(actionsInfo, "unHold") ||
            isActionAvailable ? (
              <>
                <div
                  className="row"
                  style={{ display: markDuplicateBTN == 1 ? "none" : null }}
                >
                  <h3 className="heading-actions" style={{ marginLeft: "2%" }}>
                    Actions on Issue{" "}
                  </h3>
                </div>
              </>
            ) : null}*/}
            {isLoading === STATUS.LOADING ? (
              <LoaderTemplate
                times={1}
                width={900}
                height={80}
                children={<ActionLoaderTemplate />}
              />
            ) : (
              (
                <>
                  {this.createTemplateForAction()}

                  <DisplayByPermission
                    display={get(actionsInfo, "clarification")}
                  >
                    <ToolTip
                      text={MESSAGES_CONSTANT["Reassign For Clarification"]}
                    >
                      <Button
                        className={`btn-blue no-padding-new`}
                        onClick={e => {
                          e.preventDefault();
                          e.stopPropagation();
                          this.onChange(
                            FIXED_ACTIONS["REASSIGN FOR CLARIFICATION"],
                            "action"
                          );
                        }}
                        style={{
                          width: 200,
                          display: markDuplicateBTN == 1 ? "none" : null
                        }}
                      >
                        Reassign For Clarification
                      </Button>
                    </ToolTip>
                  </DisplayByPermission>

                  <DisplayByPermission
                    display={get(actionsInfo, "forwardToTeam")}
                  >
                    <ToolTip text={MESSAGES_CONSTANT["Forward to Team"]}>
                      <Button
                        className={`btn-orange no-padding-new`}
                        onClick={e => {
                          e.preventDefault();
                          e.stopPropagation();
                          this.onChange(
                            FIXED_ACTIONS["FORWARD TO TEAM"],
                            "action"
                          );
                        }}
                        style={{
                          display: markDuplicateBTN == 1 ? "none" : null
                        }}
                      >
                        Forward
                      </Button>
                    </ToolTip>
                  </DisplayByPermission>
                  <DisplayByPermission display={get(actionsInfo, "reply")}>
                    <ToolTip text={MESSAGES_CONSTANT["Reply"]}>
                      <Button
                        className={` no-padding-new`}
                        onClick={e => {
                          e.preventDefault();
                          e.stopPropagation();
                          this.onChange(FIXED_ACTIONS.REPLY, "action");
                        }}
                        style={{
                          display: markDuplicateBTN == 1 ? "none" : null
                        }}
                      >
                        Reply
                      </Button>
                    </ToolTip>
                  </DisplayByPermission>
                  <DisplayByPermission
                    display={get(actionsInfo, "addDecision")}
                  >
                    <ToolTip text={MESSAGES_CONSTANT["Add Decision"]}>
                      <Button
                        className={`new-adddecision-btn no-padding-new shadow-none`}
                        onClick={() => {
                          this.getAgendaListForIssue();
                        }}
                        style={{
                          display: markDuplicateBTN == 1 ? "none" : null
                        }}
                      >
                        Add Decision
                      </Button>
                    </ToolTip>
                  </DisplayByPermission>

                  {/* <DisplayByPermission
                    display={get(actionsInfo, "addDecision")}
                  >
                    <ToolTip text={MESSAGES_CONSTANT["Add Decision"]}>
                      
                     <Button
                        className={`new-editdecision-btn no-padding-new shadow-none`}
                        onClick={() => {
                          this.getAgendaListForIssue();
                        }}
                       
                      >
                       <img src={NewPencilIcon} className="newpencilicon" /> Edit Issue
                      </Button> 
                    </ToolTip>
                  </DisplayByPermission> */}
                  <DisplayByPermission display={get(actionsInfo, "unHold")}>
                    <ToolTip text={MESSAGES_CONSTANT["Unhold"]}>
                      <Button
                        className={`btn-orange no-padding-new`}
                        onClick={e => {
                          e.preventDefault();
                          e.stopPropagation();
                          this.unHoldIssue();
                        }}
                        style={{
                          display: markDuplicateBTN == 1 ? "none" : null
                        }}
                      >
                        Unhold
                      </Button>
                    </ToolTip>
                  </DisplayByPermission>
                  <DisplayByPermission
                    display={get(actionsInfo, "addMoreIssue")}
                    //display={get(actionsInfo, "markAsDuplicate")}
                  >
                    <ToolTip text={MESSAGES_CONSTANT["addMoreIssue"]}>
                      <Button
                        className={`btn-orange no-padding-new button-more-issue new-add-more-issue`}
                        onClick={e => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleOnClick();
                        }}
                        style={{
                          display: markDuplicateBTN == 1 ? "none" : null
                        }}
                      >
                        + ADD MORE ISSUE(S)
                      </Button>
                    </ToolTip>
                  </DisplayByPermission>

                  {/* <DisplayByPermission
                    display={get(actionsInfo, "markAsDuplicate")}
                  >
                    <ToolTip text={MESSAGES_CONSTANT["markAsDuplicate"]}>
                      <Button
                        className={`btn-orange-invert no-padding-new button-more-issue`}
                        onClick={e => {
                          e.preventDefault();
                          e.stopPropagation();
                          this.onChange(
                            FIXED_ACTIONS["Mark_As_Duplicate"],
                            "action"
                          );
                        }}
                        style={{width:"139px",paddingLeft:"2.6%"}}
                      >
                        Mark Duplicate
                      </Button>
                    </ToolTip>
                  </DisplayByPermission> */}
                </>
              ) || null
            )}
          </React.Fragment>
        </DisplayByPermission>

        <DisplayByPermission
          //display={isActionAvailable && ACTION_TYPE !== actionType}
          display={true}
        >
          {console.log(action)}
          {(showCommentPopUp && (
            <>
              <ConfirmationComponent
                show={showCommentPopUp}
                isLoading={false}
                modalClass={"confirmation-modal"}
                saveHandler={
                  // action === "VERIFY AND SEND TO PMG" ||
                  (action === "REVIEW AND SEND TO PMG" ||
                    action === "SEND TO STATE PMG" ||
                    action === "SEND TO RECIPIENT") &&
                  projectStatus === "UNDER_VERIFICATION"
                    ? this.onVerifyProject
                    : this.setIssueStatus
                }
                closeHandler={() => {
                  this.onChange("", "action");
                }}
                content={
                  <div>
                    Are you sure you want to{" "}
                    {action == "RESOLVED & SEND TO PMG" ||
                    action == "RESOLVED AND SEND TO STATE PMG"
                      ? "resolve and send"
                      : null}
                    {/* {action == "VERIFY AND SEND TO PMG" ? "verify" : null} */}
                    {action == "REVIEW AND SEND TO PMG" ? "verify" : null}
                    {action == "SEND TO RECIPIENT MINISTRY/STATE" ||
                    action == "SEND TO STATE PMG" ||
                    action == "SEND TO RECIPIENT"
                      ? "assign"
                      : null}{" "}
                    the issue
                    {action == "SEND TO STATE PMG" ||
                    action == "RESOLVED AND SEND TO STATE PMG"
                      ? " to State PMG"
                      : null}
                    {action == "SEND TO RECIPIENT MINISTRY/STATE" ||
                    action == "SEND TO RECIPIENT"
                      ? " to recipient"
                      : null}
                    {action == "RESOLVED & SEND TO PMG" ? " to PMG" : null}?
                  </div>
                }
              />
            </>
          )) ||
            null}

          {reviewAndSentTo && (
            <>
              <ReviewAndSend
                show={reviewAndSentTo}
                isLoading={false}
                onBlur={this.onBlur}
                onRemoveFile={this.onRemoveFile}
                description={this.state.projectMom}
                errors={this.state.errors}
                files={this.state.files}
                projectMom={this.setProjectMom}
                onToggleAttachment={this.onToggleAttachment}
                toggleAttachementDisplay={toggleAttachementDisplay}
                // modalClass={"confirmation-modal"}
                saveHandler={this.checkuploadComment}
                checkBoxChange={this.checkBoxChange}
                isChecked={this.state.isChecked}
                isNotChecked={this.state.isNotChecked}
                closeHandler={() => {
                  this.onChange("", "action");
                }}
              />
            </>
          )}
          {/* <div className="forward-to-team-confirmation">
            <div className="confirmation-inner">
              {(action === "VERIFY AND SEND TO PMG" ||
                action === "SEND TO STATE PMG") &&
              projectStatus === "UNDER_VERIFICATION"
                ? "Taking this action will verify the project as well. Do you want to take this action?"
                : "Are you sure you want to take action on this issue?"}
              <div className="confirmation-buttons">
                <Button
                  className="btn-orange"
                  onClick={
                    (action === "VERIFY AND SEND TO PMG" ||
                      action === "SEND TO STATE PMG") &&
                    projectStatus === "UNDER_VERIFICATION"
                      ? this.onVerifyProject
                      : this.setIssueStatus
                  }
                >
                  Yes
                </Button>
                <Button
                  className="btn-orange-invert"
                  onClick={() => {
                    this.onChange("", "action");
                  }}
                >
                  No
                </Button>
              </div>
            </div>
          </div> */}
        </DisplayByPermission>
        <DisplayByPermission
          display={isActionAvailable && ACTION_TYPE === actionType}
        >
          <ChangeStatus
            isIssueList={isIssueList}
            headerText={""}
            action={action}
            actionType={actionType}
            issueDetails={issueDetails}
            actionDispatch={replyActionDispatch}
            callApiOnSuccess={callApiOnSuccess}
            defaultOpen={defaultOpen}
            resetAction={this.handleClose}
            onCloseButton={this.handleButtonClose}
          />
        </DisplayByPermission>

        <DisplayByPermission
          display={action === FIXED_ACTIONS["REASSIGN FOR CLARIFICATION"]}
        >
          <ReassignForClarification
            headerText="Reassign for clarification"
            issueDetails={issueDetails}
            options={askForClarificationList}
            actionDispatch={issueClarificationDispatch}
            callApiOnSuccess={callApiOnSuccess}
            defaultOpen={defaultOpen}
            resetAction={this.handleClose}
            onCloseButton={this.handleButtonClose}
            isIssueList={isIssueList}
          />
        </DisplayByPermission>

        <DisplayByPermission display={action === FIXED_ACTIONS.REPLY}>
          <ReassignForClarification
            headerText="Reply"
            issueDetails={issueDetails}
            options={[replyToList]}
            actionDispatch={replyActionDispatch}
            callApiOnSuccess={callApiOnSuccess}
            defaultOpen={defaultOpen}
            resetAction={this.handleClose}
            onCloseButton={this.handleButtonClose}
            isIssueList={isIssueList}
          />
        </DisplayByPermission>

        <DisplayByPermission
          display={action === FIXED_ACTIONS["FORWARD TO TEAM"]}
        >
          <ForwardToTeam
            issueDetails={issueDetails}
            options={get(actionsInfo, "forwardToTeamList", [])}
            callApiOnSuccess={callApiOnSuccess}
            defaultOpen={defaultOpen}
            resetAction={this.handleClose}
            onCloseButton={this.handleButtonClose}
          />
        </DisplayByPermission>

        <DisplayByPermission
          display={action === FIXED_ACTIONS["Mark_As_Duplicate"]}
        >
          <MarkAsDuplicate
            headerText="Mark As Duplicate"
            issueDetails={issueDetails}
            options={
              markAsDuplicateList && markAsDuplicateList.length
                ? markAsDuplicateList
                : []
            }
            callApiOnSuccess={callApiOnSuccess}
            defaultOpen={defaultOpen}
            resetAction={this.handleClose}
            //onCloseButton={this.handleButtonClose}
            markduplicatebtn={this.state.markduplicatebtn}
          />
        </DisplayByPermission>

        <DisplayByPermission display={action === FIXED_ACTIONS["ADD DECISION"]}>
          <AddDecision
            show={true}
            meetingListData={get(meetingListData, "data")}
            handleClose={this.handleClose}
            issues={issueDetails}
            project={
              get(issueDetails, "project") ||
              get(issueDetails, "projectIssueDTO")
            }
            callApiOnSuccess={callApiOnSuccess}
            defaultOpen={defaultOpen}
            issueListStatus={true}
            filterArray={filterArray}
            showSaveAsDraft={false}
            callFromIssueAction={true}
          />
        </DisplayByPermission>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    isApiLoading: state.issueActionReducer.isApiLoading,
    meetingStatus: state.issueDetailsReducer.meetingStatus,
    meetingListData: state.issueDetailsReducer.meetingListData
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setIssueStatusDispatch: setIssueStatusAction,
      postCommentDispatch: postCommentAction,
      getIssueListDispatch: getIssueList,
      replyActionDispatch: replyAction,
      issueClarificationDispatch: issueClarificationAction,
      getIssueMeetingByIdDispatch: getIssueMeetingByIdAction,
      getIssueDetailsDispatch: getIssueDetails,
      getProjectDetails,
      unHoldIssueAction
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(IssueActions)
);
